import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../_partials/PremiumFolderDataIcon';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
var FolderInfo = function (_a) {
    var _b;
    var folder = _a.folder;
    var t = useTranslation().t;
    var deviationCount = (_b = folder.totalItemCount) !== null && _b !== void 0 ? _b : folder.size;
    return (React.createElement("div", { className: classnames(folderDropdownDesktopStyles['info'], !!folder.parentId && folderDropdownDesktopStyles['subfolder-info']) },
        React.createElement("div", { className: folderDropdownDesktopStyles['title'] },
            React.createElement(PremiumFolderDataIcon, { premiumFolderData: folder === null || folder === void 0 ? void 0 : folder.premiumFolderData, size: IconSize.SMALL, className: folderDropdownDesktopStyles['premium-folder-icon'] }),
            folder.name),
        React.createElement("div", { className: folderDropdownDesktopStyles['stats'] }, t('gallectionDropdown.folder.stats.artworks', {
            formattedCount: shortenNumber(deviationCount),
            count: deviationCount,
        }))));
};
FolderInfo.displayName = 'FolderInfo';
export default FolderInfo;
//# sourceMappingURL=FolderInfo.js.map